export function showErrorModal(info, callback, isSetToCenter) {
  const $infoPopup = $('#info-dialog');
  
  $infoPopup.find('.content').html(info);
  $infoPopup.data("callbackScript", callback);
  $.featherlight($infoPopup, null);
}